module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_iterators.js
// module id = ./node_modules/core-js/modules/_iterators.js
// module chunks = 54 55